import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const buildingValidationSchema = Yup.object({
  constructionBuildingProcedure: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  buildingPurpose: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  requirementGroup: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  ibz: Yup.string().nullable().matches(/^\d{9}$/, 'IBZ mora sadržavati samo brojeve i imati točno 9 znamenki!'),
  buildingGrossArea: Yup.string().required(messages.MANDATORY_FIELD),
  buildingPlacement: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  buildingFloorNumberType: Yup.string().required(messages.MANDATORY_FIELD),
  constructionCommencement: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  buildingIndependentFunctionalNumber: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  buildingTypeNationalClassification: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  accessibilityRating: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  greenInfrastructureType: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
});

export const buildingValidationV2Schema = Yup.object({
  constructionBuildingProcedure: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  buildingPurpose: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  requirementGroup: Yup.array().of(Yup.object()).nonNullable(messages.MANDATORY_FIELD).min(1, messages.MANDATORY_FIELD),
  ibz: Yup.string().nullable().matches(/^\d{9}$/, 'IBZ mora sadržavati samo brojeve i imati točno 9 znamenki!'),
});
